var map = {
	"./365-and-datacamp-comparisson.png": 4305,
	"./365-logo-small-light.png": 3929,
	"./365-logo-small.png": 4306,
	"./about-us-companies.png": 3803,
	"./about-us-our-vision.png": 3810,
	"./about-us-ready-bg.png": 4307,
	"./about-us-students.png": 4308,
	"./about-us.jpg": 4309,
	"./advanced-specialization.png": 4310,
	"./alternative-page.png": 4311,
	"./b2b-img1.jpg": 3833,
	"./b2b-img1.png": 4312,
	"./b2b-img2.jpg": 3834,
	"./b2b-img2.png": 4313,
	"./b2b-img3.jpg": 3835,
	"./b2b-img3.png": 4314,
	"./b2b-img4.jpg": 3836,
	"./b2b-img4.png": 4315,
	"./b2b-img5.jpg": 3837,
	"./b2b-img5.png": 4316,
	"./b2b-img6.jpg": 3838,
	"./b2b-img6.png": 4317,
	"./b2b-preview-image-mobile.jpg": 3826,
	"./b2b-preview-image.jpg": 3824,
	"./background-scholarship-page.jpg": 4318,
	"./bf-background-desktop.jpg": 4319,
	"./bf-background-mobile.jpg": 4320,
	"./blog-banner-users-light.png": 3554,
	"./blog-banner-users-mobile.png": 4321,
	"./blog-banner-users.png": 4322,
	"./business-live-trainings-mobile.png": 3821,
	"./business-live-trainings.png": 3820,
	"./calculators/coefficient-of-variation/cov-01-faq-desktop.png": 3930,
	"./calculators/coefficient-of-variation/cov-02-faq-desktop.png": 3931,
	"./calculators/coefficient-of-variation/cov-03-faq-desktop.png": 3932,
	"./calculators/coefficient-of-variation/cov-04-faq-desktop.png": 3933,
	"./calculators/coefficient-of-variation/cov-05-faq-desktop.png": 3934,
	"./calculators/confidence-interval/confidence-interval-01-desktop.png": 3935,
	"./calculators/confidence-interval/confidence-interval-02-desktop.png": 3936,
	"./calculators/confidence-interval/confidence-interval-03-desktop.png": 3937,
	"./calculators/confidence-interval/confidence-interval-04-desktop.webp": 3938,
	"./calculators/confidence-interval/confidence-interval-05-desktop.png": 3939,
	"./calculators/confidence-interval/confidence-interval-06-desktop.webp": 3940,
	"./calculators/confidence-interval/confidence-interval-07-desktop.png": 3941,
	"./calculators/difference-in-means/dif-in-means-001.webp": 3942,
	"./calculators/difference-in-means/dif-in-means-02-mobile.webp": 3943,
	"./calculators/difference-in-means/dif-in-means-02.webp": 3944,
	"./calculators/difference-in-means/dif-in-means-faq-01.webp": 3945,
	"./calculators/difference-in-means/dif-in-means-faq-02.webp": 3946,
	"./calculators/difference-in-means/dif-in-means-faq-03.webp": 3947,
	"./calculators/difference-in-means/dif-in-means-faq-04.webp": 3948,
	"./calculators/difference-in-means/dif-in-means-faq-05.webp": 3949,
	"./calculators/difference-in-means/dif-in-means-faq-06.webp": 3950,
	"./calculators/difference-in-means/dif-in-means-faq-07.webp": 3951,
	"./calculators/hypothesis-test/hypothesis-test-002.webp": 3952,
	"./calculators/hypothesis-test/hypothesis-test-01.webp": 3953,
	"./calculators/hypothesis-test/hypothesis-test-03.webp": 3954,
	"./calculators/hypothesis-test/hypothesis-test-04-07.webp": 3763,
	"./calculators/hypothesis-test/hypothesis-test-05.webp": 3955,
	"./calculators/hypothesis-test/hypothesis-test-06.webp": 3956,
	"./calculators/hypothesis-test/hypothesis-test-08.webp": 3957,
	"./calculators/hypothesis-test/hypothesis-test-09.webp": 3958,
	"./calculators/hypothesis-test/hypothesis-test-11.webp": 3959,
	"./calculators/hypothesis-test/hypothesis-test-12-13.webp": 3764,
	"./calculators/hypothesis-test/hypothesis-test-14.webp": 3960,
	"./calculators/hypothesis-test/hypothesis-test-15.webp": 3961,
	"./calculators/hypothesis-test/hypothesis-test-16.webp": 3962,
	"./calculators/hypothesis-test/hypothesis-test-17.webp": 3963,
	"./calculators/hypothesis-test/hypothesis-test2-10.webp": 3964,
	"./calculators/kurtosis/kurtosis-01-desktop.png": 3965,
	"./calculators/kurtosis/kurtosis-02-desktop.png": 3966,
	"./calculators/kurtosis/kurtosis-03-desktop.png": 3967,
	"./calculators/kurtosis/kurtosis-04-desktop.png": 3968,
	"./calculators/kurtosis/kurtosis-05-desktop.png": 3969,
	"./calculators/kurtosis/kurtosis-07-desktop.png": 3970,
	"./calculators/kurtosis/kurtosis-08-desktop.png": 3971,
	"./calculators/kurtosis/kurtosis-faq-01-desktop.png": 3972,
	"./calculators/kurtosis/kurtosis-faq-02-desktop.png": 3973,
	"./calculators/kurtosis/kurtosis-faq-03-desktop.png": 3974,
	"./calculators/kurtosis/kurtosis2-06-desktop.png": 3975,
	"./calculators/linear-regression/linear-regression-01.webp": 3976,
	"./calculators/linear-regression/linear-regression-02.webp": 3977,
	"./calculators/linear-regression/linear-regression-03.webp": 3978,
	"./calculators/linear-regression/linear-regression-04.webp": 3979,
	"./calculators/linear-regression/linear-regression-05.webp": 3980,
	"./calculators/linear-regression/linear-regression-06.webp": 3981,
	"./calculators/linear-regression/linear-regression-08.webp": 3982,
	"./calculators/linear-regression/linear-regression-09.webp": 3983,
	"./calculators/linear-regression/linear-regression-10.webp": 3984,
	"./calculators/linear-regression/linear-regression-11.webp": 3985,
	"./calculators/linear-regression/linear-regression-12.webp": 3986,
	"./calculators/linear-regression/linear-regression-13.webp": 3987,
	"./calculators/linear-regression/linear-regression-14.webp": 3988,
	"./calculators/linear-regression/linear-regression-15.webp": 3989,
	"./calculators/linear-regression/linear-regression-16.webp": 3990,
	"./calculators/linear-regression/linear-regression-17.webp": 3991,
	"./calculators/linear-regression/linear-regression-18.webp": 3992,
	"./calculators/linear-regression/linear-regression-19.webp": 3993,
	"./calculators/linear-regression/linear-regression-20.webp": 3994,
	"./calculators/linear-regression/linear-regression-21.webp": 3995,
	"./calculators/linear-regression/linear-regression-22.webp": 3996,
	"./calculators/linear-regression/linear-regression-24.webp": 3997,
	"./calculators/linear-regression/linear-regression-25.webp": 3998,
	"./calculators/linear-regression/linear-regression2-07.webp": 3999,
	"./calculators/linear-regression/linear-regression2-23.webp": 4000,
	"./calculators/linear-regression/watermark.png": 4001,
	"./calculators/mean-median-mode/mmm-01-desktop.png": 4002,
	"./calculators/mean-median-mode/mmm-02-desktop.png": 4003,
	"./calculators/mean-median-mode/mmm-03-desktop.png": 4004,
	"./calculators/mean-median-mode/mmm-04-desktop.png": 4005,
	"./calculators/mean-median-mode/mmm-05-desktop.png": 4006,
	"./calculators/mean-median-mode/mmm-06-desktop.png": 4007,
	"./calculators/mean-median-mode/mmm-07-desktop.png": 4008,
	"./calculators/mean-median-mode/mmm-faq-01-desktop.png": 4009,
	"./calculators/mean-median-mode/mmm-faq-02-desktop.png": 4010,
	"./calculators/mean-median-mode/mmm-faq-03-desktop.png": 4011,
	"./calculators/mean-median-mode/mmm-faq-04-desktop.png": 4012,
	"./calculators/mean-median-mode/mmm-faq-05-desktop.png": 4013,
	"./calculators/mean-median-mode/mmm-faq-06-desktop.png": 4014,
	"./calculators/mean-median-mode/mmm-faq-07-desktop.png": 4015,
	"./calculators/p-value/p-value-01.webp": 4016,
	"./calculators/p-value/p-value-02.webp": 4017,
	"./calculators/p-value/p-value-03.webp": 4018,
	"./calculators/p-value/p-value-04.webp": 4019,
	"./calculators/p-value/p-value-05.webp": 4323,
	"./calculators/p-value/p-value-10-mobile.webp": 4020,
	"./calculators/p-value/p-value-10.webp": 4021,
	"./calculators/p-value/p-value-12-mobile.webp": 4022,
	"./calculators/p-value/p-value-12.webp": 4023,
	"./calculators/p-value/p-value1-06.webp": 4024,
	"./calculators/p-value/p-value1-07.webp": 4025,
	"./calculators/p-value/p-value1-08.webp": 4026,
	"./calculators/p-value/p-value1-09.webp": 4027,
	"./calculators/p-value/p-value1-11-mobile.webp": 4028,
	"./calculators/p-value/p-value1-11.webp": 4029,
	"./calculators/skewness/skewness-01-desktop.png": 4030,
	"./calculators/skewness/skewness-01-faq-desktop.png": 4031,
	"./calculators/skewness/skewness-02-desktop.png": 4032,
	"./calculators/skewness/skewness-02-faq-desktop.png": 4033,
	"./calculators/skewness/skewness-03-desktop.png": 4034,
	"./calculators/skewness/skewness-03-faq-desktop.png": 4035,
	"./calculators/skewness/skewness-04-faq-desktop.png": 4036,
	"./calculators/skewness/skewness-05-desktop.png": 4037,
	"./calculators/skewness/skewness-05-faq-desktop.png": 4038,
	"./calculators/skewness/skewness-06-desktop.png": 4039,
	"./calculators/skewness/skewness-06-faq-desktop.png": 4040,
	"./calculators/skewness/skewness-07-desktop.png": 4041,
	"./calculators/skewness/skewness-07-faq-desktop.png": 4042,
	"./calculators/skewness/skewness-08-desktop.png": 4043,
	"./calculators/skewness/skewness-09-desktop.png": 4044,
	"./calculators/skewness/skewness-10-desktop.png": 4045,
	"./calculators/skewness/skewness-11-desktop.png": 4046,
	"./calculators/skewness/skewness-12-desktop.png": 4047,
	"./calculators/skewness/skewness-13-desktop.png": 4048,
	"./calculators/skewness/skewness-14-desktop.png": 4049,
	"./calculators/skewness/skewness-15-desktop.png": 4050,
	"./calculators/skewness/skewness-16-desktop.png": 4051,
	"./calculators/skewness/skewness-17-desktop.png": 4052,
	"./calculators/skewness/skewness2-04-desktop.png": 4053,
	"./calculators/skewness/zoomed-first.png": 4054,
	"./calculators/skewness/zoomed-second.png": 4055,
	"./calculators/standard-deviation/sd-01-faq-desktop.png": 4056,
	"./calculators/standard-deviation/sd-02-desktop.png": 4057,
	"./calculators/standard-deviation/sd-02-faq-desktop.png": 4058,
	"./calculators/standard-deviation/sd-03-desktop.png": 4059,
	"./calculators/standard-deviation/sd-03-faq-desktop.png": 4060,
	"./calculators/standard-deviation/sd-04-desktop.png": 4061,
	"./calculators/standard-deviation/sd-04-faq-desktop.png": 4062,
	"./calculators/standard-deviation/sd-05-desktop.png": 4063,
	"./calculators/standard-deviation/sd-05-faq-desktop.png": 4064,
	"./calculators/standard-deviation/sd2-01-desktop.png": 4065,
	"./calculators/standard-deviation/sd2-06-desktop.png": 4066,
	"./campaigns/bf-landing/blog-banner.png": 1493,
	"./campaigns/bf-landing/cards.jpg": 1494,
	"./campaigns/bf-landing/career-tracks.jpg": 1495,
	"./campaigns/bf-landing/certificates.jpg": 1496,
	"./campaigns/bf-landing/exams.jpg": 1497,
	"./campaigns/bf-landing/foot-glitches.png": 1498,
	"./campaigns/bf-landing/hero-glitches.png": 1499,
	"./campaigns/bf-landing/instructors/anastasia.jpg": 1500,
	"./campaigns/bf-landing/instructors/andrew.jpg": 1501,
	"./campaigns/bf-landing/instructors/bernard.jpg": 1502,
	"./campaigns/bf-landing/instructors/danielle.jpg": 1503,
	"./campaigns/bf-landing/instructors/davis.jpg": 1504,
	"./campaigns/bf-landing/instructors/elitsa.jpg": 1505,
	"./campaigns/bf-landing/instructors/giles.jpg": 1506,
	"./campaigns/bf-landing/instructors/harpreet.jpg": 1507,
	"./campaigns/bf-landing/instructors/ken.jpg": 1508,
	"./campaigns/bf-landing/instructors/olivier.jpg": 1509,
	"./campaigns/bf-landing/instructors/randy.jpg": 1510,
	"./campaigns/bf-landing/instructors/tina.jpg": 1511,
	"./campaigns/bf-landing/leaderboard.jpg": 1512,
	"./campaigns/bf-landing/sticky-banner-bg.png": 1513,
	"./campaigns/bf-landing/video-thumb-ahmed.jpg": 1514,
	"./campaigns/bf-landing/video-thumb-ernest.jpg": 1515,
	"./campaigns/bf-landing/video-thumb-lee.jpg": 1516,
	"./campaigns/bf-landing/video-thumb-meghan.jpg": 1517,
	"./campaigns/bf-landing/video-thumb-nada.jpg": 1518,
	"./campaigns/bf-landing/xp-coins.jpg": 1519,
	"./campaigns/cm-banners/cm-blog-banner-visuals-1.png": 1329,
	"./campaigns/cm-banners/cm-blog-banner-visuals-2.png": 1330,
	"./campaigns/cm-banners/cm-blog-banner-visuals-3.png": 1331,
	"./campaigns/cm-banners/cm-blog-banner-visuals-4.png": 1332,
	"./campaigns/cm-banners/cyber-monday-blog-banner.png": 1333,
	"./campaigns/cm-ext-label-mobile.webp": 715,
	"./campaigns/cm-ext-label.webp": 514,
	"./campaigns/cyber-monday-landing/backgrounds/banner-bg.jpg": 1520,
	"./campaigns/cyber-monday-landing/backgrounds/card-bg.png": 1521,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg1-mobile.png": 1522,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg2-mobile.png": 1523,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg-mobile.png": 1524,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg.jpg": 1525,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg-mobile.png": 1526,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg.jpg": 1527,
	"./campaigns/cyber-monday-landing/backgrounds/header-bg.png": 1528,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg-mobile.png": 1529,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg.jpg": 1530,
	"./campaigns/cyber-monday-landing/cm-cards.jpg": 1531,
	"./campaigns/cyber-monday-landing/cm-career-tracks.jpg": 1532,
	"./campaigns/cyber-monday-landing/cm-certificates.jpg": 1533,
	"./campaigns/cyber-monday-landing/cm-exams.jpg": 1534,
	"./campaigns/cyber-monday-landing/cm-leaderboard.jpg": 1535,
	"./campaigns/cyber-monday-landing/cm-xp-coins.jpg": 1536,
	"./campaigns/ds-bf-bg-blog-banner.webp": 548,
	"./campaigns/ds-bf-bg-bottom-banner.webp": 716,
	"./campaigns/ds-bf-bg-footer-mobile2.webp": 717,
	"./campaigns/ds-bf-bg-footer.webp": 718,
	"./campaigns/ds-bf-bg-hero-mobile.webp": 719,
	"./campaigns/ds-bf-bg-hero.webp": 720,
	"./campaigns/ds-bf-certificate.webp": 721,
	"./campaigns/ds-bf-channels.webp": 722,
	"./campaigns/ds-bf-clp.webp": 723,
	"./campaigns/ds-bf-exams.webp": 724,
	"./campaigns/ds-bf-leaderboard.webp": 725,
	"./campaigns/ds-bf-projects.webp": 726,
	"./campaigns/ds-bf-resume.webp": 727,
	"./campaigns/ds-bf-title-benefit-mobile.webp": 728,
	"./campaigns/ds-bf-title-benefit.webp": 729,
	"./campaigns/ds-bf-title-courses-mobile.webp": 730,
	"./campaigns/ds-bf-title-courses.webp": 731,
	"./campaigns/ds-bf-title-hero-mobile.webp": 732,
	"./campaigns/ds-bf-title-hero.webp": 515,
	"./campaigns/ds-bf-title-offer.webp": 733,
	"./campaigns/ds-bf-title-projects-mobile.webp": 734,
	"./campaigns/ds-bf-title-projects.webp": 735,
	"./campaigns/ds-bf-tracks.webp": 736,
	"./campaigns/ds-bf2024-bg-bottom-banner-mobile.webp": 737,
	"./campaigns/ds-bf2024-bg-bottom-banner.webp": 644,
	"./campaigns/ds-bf2024-bg-footer-mobile.webp": 738,
	"./campaigns/ds-bf2024-bg-footer.webp": 739,
	"./campaigns/ds-bf2024-bg-hero-laptop.webp": 740,
	"./campaigns/ds-bf2024-bg-hero-mobile.webp": 741,
	"./campaigns/ds-bf2024-bg-hero.webp": 742,
	"./campaigns/ds-bf2024-certificates.webp": 743,
	"./campaigns/ds-bf2024-clp.webp": 744,
	"./campaigns/ds-bf2024-exams.webp": 745,
	"./campaigns/ds-bf2024-exercises.webp": 746,
	"./campaigns/ds-bf2024-hero-stamp.webp": 642,
	"./campaigns/ds-bf2024-instructor-anastasia-kuznetsova-mobile.webp": 747,
	"./campaigns/ds-bf2024-instructor-anastasia-kuznetsova.webp": 748,
	"./campaigns/ds-bf2024-instructor-bernard-marr-mobile.webp": 749,
	"./campaigns/ds-bf2024-instructor-bernard-marr.webp": 750,
	"./campaigns/ds-bf2024-instructor-danielle-the-mobile.webp": 751,
	"./campaigns/ds-bf2024-instructor-danielle-the.webp": 752,
	"./campaigns/ds-bf2024-instructor-davis-balaba-mobile.webp": 753,
	"./campaigns/ds-bf2024-instructor-davis-balaba.webp": 754,
	"./campaigns/ds-bf2024-instructor-jeff-li-mobile.webp": 755,
	"./campaigns/ds-bf2024-instructor-jeff-li.webp": 756,
	"./campaigns/ds-bf2024-instructor-ken-jee-mobile.webp": 757,
	"./campaigns/ds-bf2024-instructor-ken-jee.webp": 758,
	"./campaigns/ds-bf2024-instructor-lauren-newbould-mobile.webp": 759,
	"./campaigns/ds-bf2024-instructor-lauren-newbould.webp": 760,
	"./campaigns/ds-bf2024-instructor-olivier-maugain-mobile.webp": 761,
	"./campaigns/ds-bf2024-instructor-olivier-maugain.webp": 762,
	"./campaigns/ds-bf2024-instructor-randy-rosseel-mobile.webp": 763,
	"./campaigns/ds-bf2024-instructor-randy-rosseel.webp": 764,
	"./campaigns/ds-bf2024-instructor-shashank-kalanithi-mobile.webp": 765,
	"./campaigns/ds-bf2024-instructor-shashank-kalanithi.webp": 766,
	"./campaigns/ds-bf2024-instructor-tina-huang-mobile.webp": 767,
	"./campaigns/ds-bf2024-instructor-tina-huang.webp": 768,
	"./campaigns/ds-bf2024-projects.webp": 769,
	"./campaigns/ds-bf2024-tracks.webp": 770,
	"./campaigns/ds-cm-bg-blog-banner.webp": 549,
	"./campaigns/ds-cm-bg-bottom-banner.webp": 771,
	"./campaigns/ds-cm-bg-footer-mobile.webp": 772,
	"./campaigns/ds-cm-bg-footer.webp": 773,
	"./campaigns/ds-cm-bg-hero-mobile.webp": 774,
	"./campaigns/ds-cm-bg-hero.webp": 775,
	"./campaigns/ds-cm-bg-page-laptop.webp": 776,
	"./campaigns/ds-cm-bg-page-mobile.webp": 777,
	"./campaigns/ds-cm-bg-page.webp": 778,
	"./campaigns/ds-cm-certificate.webp": 779,
	"./campaigns/ds-cm-channels.webp": 780,
	"./campaigns/ds-cm-clp.webp": 781,
	"./campaigns/ds-cm-exams.webp": 782,
	"./campaigns/ds-cm-leaderboard.webp": 783,
	"./campaigns/ds-cm-projects.webp": 784,
	"./campaigns/ds-cm-resume.webp": 785,
	"./campaigns/ds-cm-title-benefit.webp": 786,
	"./campaigns/ds-cm-title-courses-mobile.webp": 787,
	"./campaigns/ds-cm-title-courses.webp": 788,
	"./campaigns/ds-cm-title-hero-mobile.webp": 789,
	"./campaigns/ds-cm-title-hero2.webp": 516,
	"./campaigns/ds-cm-title-offer.webp": 790,
	"./campaigns/ds-cm-title-projects-mobile.webp": 791,
	"./campaigns/ds-cm-title-projects.webp": 792,
	"./campaigns/ds-cm-tracks.webp": 793,
	"./campaigns/ds-cm-xp.webp": 794,
	"./campaigns/ds-cm2024-bg-bottom-banner.webp": 645,
	"./campaigns/ds-cm2024-bg-footer-mobile.webp": 795,
	"./campaigns/ds-cm2024-bg-footer.webp": 796,
	"./campaigns/ds-cm2024-bg-hero-laptop.webp": 797,
	"./campaigns/ds-cm2024-bg-hero-mobile.webp": 798,
	"./campaigns/ds-cm2024-bg-hero.webp": 799,
	"./campaigns/ds-cm2024-certificates.webp": 800,
	"./campaigns/ds-cm2024-clp.webp": 801,
	"./campaigns/ds-cm2024-exams.webp": 802,
	"./campaigns/ds-cm2024-exercises.webp": 803,
	"./campaigns/ds-cm2024-hero-stamp.webp": 646,
	"./campaigns/ds-cm2024-instructor-anastasia-kuznetsova-mobile.webp": 804,
	"./campaigns/ds-cm2024-instructor-anastasia-kuznetsova.webp": 805,
	"./campaigns/ds-cm2024-instructor-bernard-marr-mobile.webp": 806,
	"./campaigns/ds-cm2024-instructor-bernard-marr.webp": 807,
	"./campaigns/ds-cm2024-instructor-danielle-the-mobile.webp": 808,
	"./campaigns/ds-cm2024-instructor-danielle-the.webp": 809,
	"./campaigns/ds-cm2024-instructor-davis-balaba-mobile.webp": 810,
	"./campaigns/ds-cm2024-instructor-davis-balaba.webp": 811,
	"./campaigns/ds-cm2024-instructor-jeff-li-mobile.webp": 812,
	"./campaigns/ds-cm2024-instructor-jeff-li.webp": 813,
	"./campaigns/ds-cm2024-instructor-ken-jee-mobile.webp": 814,
	"./campaigns/ds-cm2024-instructor-ken-jee.webp": 815,
	"./campaigns/ds-cm2024-instructor-lauren-newbould-mobile.webp": 816,
	"./campaigns/ds-cm2024-instructor-lauren-newbould.webp": 817,
	"./campaigns/ds-cm2024-instructor-olivier-maugain-mobile.webp": 818,
	"./campaigns/ds-cm2024-instructor-olivier-maugain.webp": 819,
	"./campaigns/ds-cm2024-instructor-randy-rosseel-mobile.webp": 820,
	"./campaigns/ds-cm2024-instructor-randy-rosseel.webp": 821,
	"./campaigns/ds-cm2024-instructor-shashank-kalanithi-mobile.webp": 822,
	"./campaigns/ds-cm2024-instructor-shashank-kalanithi.webp": 823,
	"./campaigns/ds-cm2024-instructor-tina-huang-mobile.webp": 824,
	"./campaigns/ds-cm2024-instructor-tina-huang.webp": 825,
	"./campaigns/ds-cm2024-projects.webp": 826,
	"./campaigns/ds-cm2024-tracks.webp": 827,
	"./campaigns/ds-cme-bg-blog-banner.webp": 550,
	"./campaigns/ds-cme-certificate.webp": 828,
	"./campaigns/ds-cme-channels.webp": 829,
	"./campaigns/ds-cme-clp.webp": 830,
	"./campaigns/ds-cme-exams.webp": 831,
	"./campaigns/ds-cme-leaderboard.webp": 832,
	"./campaigns/ds-cme-projects.webp": 833,
	"./campaigns/ds-cme-resume.webp": 834,
	"./campaigns/ds-cme-tracks.webp": 835,
	"./campaigns/ds-cme-xp.webp": 836,
	"./campaigns/ds-cml2024-bg-bottom-banner-laptop.webp": 837,
	"./campaigns/ds-cml2024-bg-bottom-banner-mobile.webp": 838,
	"./campaigns/ds-cml2024-bg-bottom-banner.webp": 647,
	"./campaigns/ds-cml2024-bg-footer-mobile.webp": 839,
	"./campaigns/ds-cml2024-bg-footer.webp": 840,
	"./campaigns/ds-cml2024-bg-hero-laptop.webp": 841,
	"./campaigns/ds-cml2024-bg-hero-mobile.webp": 842,
	"./campaigns/ds-cml2024-bg-hero.webp": 843,
	"./campaigns/ds-cml2024-certificates.webp": 844,
	"./campaigns/ds-cml2024-clp.webp": 845,
	"./campaigns/ds-cml2024-exams.webp": 846,
	"./campaigns/ds-cml2024-exercises.webp": 847,
	"./campaigns/ds-cml2024-hero-stamp.webp": 648,
	"./campaigns/ds-cml2024-instructor-anastasia-kuznetsova-mobile.webp": 848,
	"./campaigns/ds-cml2024-instructor-anastasia-kuznetsova.webp": 849,
	"./campaigns/ds-cml2024-instructor-bernard-marr-mobile.webp": 850,
	"./campaigns/ds-cml2024-instructor-bernard-marr.webp": 851,
	"./campaigns/ds-cml2024-instructor-danielle-the-mobile.webp": 852,
	"./campaigns/ds-cml2024-instructor-danielle-the.webp": 853,
	"./campaigns/ds-cml2024-instructor-davis-balaba-mobile.webp": 854,
	"./campaigns/ds-cml2024-instructor-davis-balaba.webp": 855,
	"./campaigns/ds-cml2024-instructor-jeff-li-mobile.webp": 856,
	"./campaigns/ds-cml2024-instructor-jeff-li.webp": 857,
	"./campaigns/ds-cml2024-instructor-ken-jee-mobile.webp": 858,
	"./campaigns/ds-cml2024-instructor-ken-jee.webp": 859,
	"./campaigns/ds-cml2024-instructor-lauren-newbould-mobile.webp": 860,
	"./campaigns/ds-cml2024-instructor-lauren-newbould.webp": 861,
	"./campaigns/ds-cml2024-instructor-olivier-maugain-mobile.webp": 862,
	"./campaigns/ds-cml2024-instructor-olivier-maugain.webp": 863,
	"./campaigns/ds-cml2024-instructor-randy-rosseel-mobile.webp": 864,
	"./campaigns/ds-cml2024-instructor-randy-rosseel.webp": 865,
	"./campaigns/ds-cml2024-instructor-shashank-kalanithi-mobile.webp": 866,
	"./campaigns/ds-cml2024-instructor-shashank-kalanithi.webp": 867,
	"./campaigns/ds-cml2024-instructor-tina-huang-mobile.webp": 868,
	"./campaigns/ds-cml2024-instructor-tina-huang.webp": 869,
	"./campaigns/ds-cml2024-projects.webp": 870,
	"./campaigns/ds-cml2024-tracks.webp": 871,
	"./campaigns/ds-fp2024-bg-bottom-banner-mobile.webp": 872,
	"./campaigns/ds-fp2024-bg-bottom-banner.webp": 614,
	"./campaigns/ds-fp2024-bg-footer-mobile.webp": 873,
	"./campaigns/ds-fp2024-bg-footer.webp": 874,
	"./campaigns/ds-fp2024-bg-hero-mobile.webp": 875,
	"./campaigns/ds-fp2024-bg-hero.webp": 876,
	"./campaigns/ds-fp2024-hero-stamp.webp": 649,
	"./campaigns/ds-fp2024-master-mobile.webp": 877,
	"./campaigns/ds-fp2024-master.webp": 878,
	"./campaigns/ds-fw-bg-bottom-banner.webp": 650,
	"./campaigns/ds-fw-bg-footer-final.webp": 879,
	"./campaigns/ds-fw-bg-footer-mobile-final.webp": 880,
	"./campaigns/ds-fw-bg-hero-mobile-final.webp": 881,
	"./campaigns/ds-fw-bg-hero.webp": 882,
	"./campaigns/ds-fw-blog-banner.webp": 551,
	"./campaigns/ds-fw-certificate.webp": 883,
	"./campaigns/ds-fw-channels.webp": 884,
	"./campaigns/ds-fw-clp.webp": 885,
	"./campaigns/ds-fw-exams.webp": 886,
	"./campaigns/ds-fw-leaderboard.webp": 887,
	"./campaigns/ds-fw-projects.webp": 888,
	"./campaigns/ds-fw-resume.webp": 889,
	"./campaigns/ds-fw-tracks.webp": 890,
	"./campaigns/ds-fw-xp.webp": 891,
	"./campaigns/ds-fw2024-banner-mobile.webp": 892,
	"./campaigns/ds-fw2024-banner.webp": 893,
	"./campaigns/ds-fw2024-bg-bottom-banner-mobile.webp": 894,
	"./campaigns/ds-fw2024-bg-bottom-banner.webp": 651,
	"./campaigns/ds-fw2024-bg-btn-laptop.webp": 895,
	"./campaigns/ds-fw2024-bg-btn-mobile.webp": 896,
	"./campaigns/ds-fw2024-bg-btn.webp": 897,
	"./campaigns/ds-fw2024-bg-footer-laptop.webp": 898,
	"./campaigns/ds-fw2024-bg-footer-mobile.webp": 899,
	"./campaigns/ds-fw2024-bg-footer.webp": 900,
	"./campaigns/ds-fw2024-bg-hero-laptop.webp": 901,
	"./campaigns/ds-fw2024-bg-hero-mobile.webp": 902,
	"./campaigns/ds-fw2024-bg-hero.webp": 903,
	"./campaigns/ds-fw2024-certificates.webp": 904,
	"./campaigns/ds-fw2024-clp.webp": 905,
	"./campaigns/ds-fw2024-exams.webp": 906,
	"./campaigns/ds-fw2024-exercises.webp": 907,
	"./campaigns/ds-fw2024-projects.webp": 908,
	"./campaigns/ds-fw2024-tracks.webp": 909,
	"./campaigns/ds-js2025-bg-bottom-banner-laptop.webp": 910,
	"./campaigns/ds-js2025-bg-bottom-banner-mobile.webp": 911,
	"./campaigns/ds-js2025-bg-bottom-banner.webp": 912,
	"./campaigns/ds-js2025-bg-footer-mobile.webp": 913,
	"./campaigns/ds-js2025-bg-footer.webp": 914,
	"./campaigns/ds-js2025-bg-hero-mobile.webp": 915,
	"./campaigns/ds-js2025-bg-hero.webp": 916,
	"./campaigns/ds-js2025-certificates.webp": 917,
	"./campaigns/ds-js2025-clp.webp": 918,
	"./campaigns/ds-js2025-exams.webp": 919,
	"./campaigns/ds-js2025-exercises.webp": 920,
	"./campaigns/ds-js2025-instructor-anastasia-kuznetsova-mobile.webp": 921,
	"./campaigns/ds-js2025-instructor-anastasia-kuznetsova.webp": 922,
	"./campaigns/ds-js2025-instructor-bernard-marr-mobile.webp": 923,
	"./campaigns/ds-js2025-instructor-bernard-marr.webp": 924,
	"./campaigns/ds-js2025-instructor-danielle-the-mobile.webp": 925,
	"./campaigns/ds-js2025-instructor-danielle-the.webp": 926,
	"./campaigns/ds-js2025-instructor-davis-balaba-mobile.webp": 927,
	"./campaigns/ds-js2025-instructor-davis-balaba.webp": 928,
	"./campaigns/ds-js2025-instructor-jeff-li-mobile.webp": 929,
	"./campaigns/ds-js2025-instructor-jeff-li.webp": 930,
	"./campaigns/ds-js2025-instructor-ken-jee-mobile.webp": 931,
	"./campaigns/ds-js2025-instructor-ken-jee.webp": 932,
	"./campaigns/ds-js2025-instructor-lauren-newbould-mobile.webp": 933,
	"./campaigns/ds-js2025-instructor-lauren-newbould.webp": 934,
	"./campaigns/ds-js2025-instructor-olivier-maugain-mobile.webp": 935,
	"./campaigns/ds-js2025-instructor-olivier-maugain.webp": 936,
	"./campaigns/ds-js2025-instructor-randy-rosseel-mobile.webp": 937,
	"./campaigns/ds-js2025-instructor-randy-rosseel.webp": 938,
	"./campaigns/ds-js2025-instructor-shashank-kalanithi-mobile.webp": 939,
	"./campaigns/ds-js2025-instructor-shashank-kalanithi.webp": 940,
	"./campaigns/ds-js2025-instructor-tina-huang-mobile.webp": 941,
	"./campaigns/ds-js2025-instructor-tina-huang.webp": 942,
	"./campaigns/ds-js2025-projects.webp": 943,
	"./campaigns/ds-js2025-tracks.webp": 944,
	"./campaigns/ds-lda-bg-bottom-banner-mobile.webp": 945,
	"./campaigns/ds-lda-bg-bottom-banner.webp": 652,
	"./campaigns/ds-lda-bg-footer-mobile.webp": 946,
	"./campaigns/ds-lda-bg-footer.webp": 947,
	"./campaigns/ds-lda-bg-hero-mobile.webp": 948,
	"./campaigns/ds-lda-bg-hero.webp": 949,
	"./campaigns/ds-lda-hero-stamp.webp": 653,
	"./campaigns/ds-lda-instructor-anastasia-kuznetsova-mobile.webp": 654,
	"./campaigns/ds-lda-instructor-anastasia-kuznetsova.webp": 655,
	"./campaigns/ds-lda-instructor-bernard-marr-mobile.webp": 656,
	"./campaigns/ds-lda-instructor-bernard-marr.webp": 657,
	"./campaigns/ds-lda-instructor-danielle-the-mobile.webp": 658,
	"./campaigns/ds-lda-instructor-danielle-the.webp": 659,
	"./campaigns/ds-lda-instructor-davis-balaba-mobile.webp": 660,
	"./campaigns/ds-lda-instructor-davis-balaba.webp": 661,
	"./campaigns/ds-lda-instructor-jeff-li-1-mobile.webp": 662,
	"./campaigns/ds-lda-instructor-jeff-li-1.webp": 663,
	"./campaigns/ds-lda-instructor-ken-jee-mobile.webp": 664,
	"./campaigns/ds-lda-instructor-ken-jee.webp": 665,
	"./campaigns/ds-lda-instructor-lauren-newbould-1-mobile.webp": 666,
	"./campaigns/ds-lda-instructor-lauren-newbould-1.webp": 667,
	"./campaigns/ds-lda-instructor-olivier-maugain-mobile.webp": 668,
	"./campaigns/ds-lda-instructor-olivier-maugain.webp": 669,
	"./campaigns/ds-lda-instructor-randy-rosseel-mobile.webp": 670,
	"./campaigns/ds-lda-instructor-randy-rosseel.webp": 671,
	"./campaigns/ds-lda-instructor-shashank-kalanithi-1-mobile.webp": 672,
	"./campaigns/ds-lda-instructor-shashank-kalanithi-1.webp": 673,
	"./campaigns/ds-lda-instructor-tina-huang-mobile.webp": 674,
	"./campaigns/ds-lda-instructor-tina-huang.webp": 675,
	"./campaigns/ds-mw-bg-bottom-banner.webp": 676,
	"./campaigns/ds-mw-bg-footer-mobile.webp": 950,
	"./campaigns/ds-mw-bg-footer.webp": 951,
	"./campaigns/ds-mw-bg-hero-mobile.webp": 952,
	"./campaigns/ds-mw-bg-hero.webp": 953,
	"./campaigns/ds-mw-certificate.webp": 954,
	"./campaigns/ds-mw-channels.webp": 955,
	"./campaigns/ds-mw-clp.webp": 956,
	"./campaigns/ds-mw-exams.webp": 957,
	"./campaigns/ds-mw-hero-stamp.webp": 677,
	"./campaigns/ds-mw-leaderboard.webp": 958,
	"./campaigns/ds-mw-projects.webp": 959,
	"./campaigns/ds-mw-resume.webp": 960,
	"./campaigns/ds-mw-tracks.webp": 961,
	"./campaigns/ds-mw-xp.webp": 962,
	"./campaigns/ds-oth-bg-bottom-banner.webp": 678,
	"./campaigns/ds-oth-bg-hero-mobile.webp": 963,
	"./campaigns/ds-oth-bg-hero.webp": 964,
	"./campaigns/ds-oth-certificate.webp": 965,
	"./campaigns/ds-oth-channels.webp": 966,
	"./campaigns/ds-oth-clp.webp": 967,
	"./campaigns/ds-oth-exams.webp": 968,
	"./campaigns/ds-oth-leaderboard.webp": 969,
	"./campaigns/ds-oth-projects.webp": 970,
	"./campaigns/ds-oth-resume.webp": 971,
	"./campaigns/ds-oth-tracks.webp": 972,
	"./campaigns/ds-oth-xp.webp": 973,
	"./campaigns/ds-tyf-bg-blog-banner.webp": 552,
	"./campaigns/ds-tyf-bg-bottom-banner.webp": 974,
	"./campaigns/ds-tyf-bg-footer-mobile.webp": 975,
	"./campaigns/ds-tyf-bg-footer.webp": 976,
	"./campaigns/ds-tyf-bg-hero-mobile.webp": 977,
	"./campaigns/ds-tyf-bg-hero.webp": 978,
	"./campaigns/ds-tyf-certificate.webp": 979,
	"./campaigns/ds-tyf-channels.webp": 980,
	"./campaigns/ds-tyf-clp.webp": 981,
	"./campaigns/ds-tyf-exams.webp": 982,
	"./campaigns/ds-tyf-leaderboard.webp": 983,
	"./campaigns/ds-tyf-projects.webp": 984,
	"./campaigns/ds-tyf-resume.webp": 985,
	"./campaigns/ds-tyf-tracks.webp": 986,
	"./campaigns/ds-tyf-xp.webp": 987,
	"./campaigns/fa-bf-bg-bottom-banner.webp": 988,
	"./campaigns/fa-bf-bg-footer-mobile2.webp": 989,
	"./campaigns/fa-bf-bg-footer.webp": 990,
	"./campaigns/fa-bf-bg-hero-mobile.webp": 991,
	"./campaigns/fa-bf-bg-hero.webp": 992,
	"./campaigns/fa-bf-certificate.webp": 993,
	"./campaigns/fa-bf-channels.webp": 994,
	"./campaigns/fa-bf-clp.webp": 995,
	"./campaigns/fa-bf-exams.webp": 996,
	"./campaigns/fa-bf-hero-title-mobile.webp": 997,
	"./campaigns/fa-bf-hero-title.webp": 998,
	"./campaigns/fa-bf-leaderboard.webp": 999,
	"./campaigns/fa-bf-projects.webp": 1000,
	"./campaigns/fa-bf-resume.webp": 1001,
	"./campaigns/fa-bf-title-benefit-mobile.webp": 1002,
	"./campaigns/fa-bf-title-benefit.webp": 1003,
	"./campaigns/fa-bf-title-courses-mobile.webp": 1004,
	"./campaigns/fa-bf-title-courses.webp": 1005,
	"./campaigns/fa-bf-title-hero-mobile.webp": 1006,
	"./campaigns/fa-bf-title-hero.webp": 517,
	"./campaigns/fa-bf-title-offer.webp": 1007,
	"./campaigns/fa-bf-title-reviews.webp": 1008,
	"./campaigns/fa-bf-tracks.webp": 1009,
	"./campaigns/fa-bf-xp.webp": 1010,
	"./campaigns/fa-bf2024-bg-bottom-banner-mobile.webp": 1011,
	"./campaigns/fa-bf2024-bg-bottom-banner.webp": 679,
	"./campaigns/fa-bf2024-bg-footer-mobile.webp": 1012,
	"./campaigns/fa-bf2024-bg-footer.webp": 1013,
	"./campaigns/fa-bf2024-bg-hero-laptop.webp": 1014,
	"./campaigns/fa-bf2024-bg-hero-mobile.webp": 1015,
	"./campaigns/fa-bf2024-bg-hero.webp": 1016,
	"./campaigns/fa-bf2024-certificates.webp": 1017,
	"./campaigns/fa-bf2024-clp.webp": 1018,
	"./campaigns/fa-bf2024-exams.webp": 1019,
	"./campaigns/fa-bf2024-exercises.webp": 1020,
	"./campaigns/fa-bf2024-hero-stamp.webp": 643,
	"./campaigns/fa-bf2024-instructor-antoniya-baltova-mobile.webp": 1021,
	"./campaigns/fa-bf2024-instructor-antoniya-baltova.webp": 1022,
	"./campaigns/fa-bf2024-instructor-gilbert-eijkelenboom-mobile.webp": 1023,
	"./campaigns/fa-bf2024-instructor-gilbert-eijkelenboom.webp": 1024,
	"./campaigns/fa-bf2024-instructor-iliya-valchanov-mobile.webp": 1025,
	"./campaigns/fa-bf2024-instructor-iliya-valchanov.webp": 1026,
	"./campaigns/fa-bf2024-instructor-ivan-kitov-mobile.webp": 1027,
	"./campaigns/fa-bf2024-instructor-ivan-kitov.webp": 1028,
	"./campaigns/fa-bf2024-instructor-ivan-vaptsarov-mobile.webp": 1029,
	"./campaigns/fa-bf2024-instructor-ivan-vaptsarov.webp": 1030,
	"./campaigns/fa-bf2024-instructor-martin-ganchev-mobile.webp": 1031,
	"./campaigns/fa-bf2024-instructor-martin-ganchev.webp": 1032,
	"./campaigns/fa-bf2024-instructor-ned-krastev-mobile.webp": 1033,
	"./campaigns/fa-bf2024-instructor-ned-krastev.webp": 1034,
	"./campaigns/fa-bf2024-instructor-peter-lipovyanov-mobile.webp": 1035,
	"./campaigns/fa-bf2024-instructor-peter-lipovyanov.webp": 1036,
	"./campaigns/fa-bf2024-instructor-randy-rosseel-mobile.webp": 1037,
	"./campaigns/fa-bf2024-instructor-randy-rosseel.webp": 1038,
	"./campaigns/fa-bf2024-instructor-valentina-bogdanova-mobile.webp": 1039,
	"./campaigns/fa-bf2024-instructor-valentina-bogdanova.webp": 1040,
	"./campaigns/fa-bf2024-projects.webp": 1041,
	"./campaigns/fa-bf2024-tracks.webp": 1042,
	"./campaigns/fa-cm-bg-bottom-banner.webp": 1043,
	"./campaigns/fa-cm-bg-footer-mobile.webp": 1044,
	"./campaigns/fa-cm-bg-footer.webp": 1045,
	"./campaigns/fa-cm-bg-hero-mobile.webp": 1046,
	"./campaigns/fa-cm-bg-hero.webp": 1047,
	"./campaigns/fa-cm-certificate.webp": 1048,
	"./campaigns/fa-cm-channels.webp": 1049,
	"./campaigns/fa-cm-clp.webp": 1050,
	"./campaigns/fa-cm-exams.webp": 1051,
	"./campaigns/fa-cm-leaderboard.webp": 1052,
	"./campaigns/fa-cm-projects.webp": 1053,
	"./campaigns/fa-cm-resume.webp": 1054,
	"./campaigns/fa-cm-title-benefit.webp": 1055,
	"./campaigns/fa-cm-title-courses-mobile.webp": 1056,
	"./campaigns/fa-cm-title-courses.webp": 1057,
	"./campaigns/fa-cm-title-hero-mobile.webp": 1058,
	"./campaigns/fa-cm-title-hero2.webp": 518,
	"./campaigns/fa-cm-title-offer.webp": 1059,
	"./campaigns/fa-cm-title-reviews.webp": 1060,
	"./campaigns/fa-cm-tracks.webp": 1061,
	"./campaigns/fa-cm-xp.webp": 1062,
	"./campaigns/fa-cm2024-bg-bottom-banner.webp": 680,
	"./campaigns/fa-cm2024-bg-footer-mobile.webp": 1063,
	"./campaigns/fa-cm2024-bg-footer.webp": 1064,
	"./campaigns/fa-cm2024-bg-hero-laptop.webp": 1065,
	"./campaigns/fa-cm2024-bg-hero-mobile.webp": 1066,
	"./campaigns/fa-cm2024-bg-hero.webp": 1067,
	"./campaigns/fa-cm2024-certificates.webp": 1068,
	"./campaigns/fa-cm2024-clp.webp": 1069,
	"./campaigns/fa-cm2024-exams.webp": 1070,
	"./campaigns/fa-cm2024-exercises.webp": 1071,
	"./campaigns/fa-cm2024-hero-stamp.webp": 681,
	"./campaigns/fa-cm2024-instructor-antoniya-baltova-mobile.webp": 1072,
	"./campaigns/fa-cm2024-instructor-antoniya-baltova.webp": 1073,
	"./campaigns/fa-cm2024-instructor-gilbert-eijkelenboom-mobile.webp": 1074,
	"./campaigns/fa-cm2024-instructor-gilbert-eijkelenboom.webp": 1075,
	"./campaigns/fa-cm2024-instructor-iliya-valchanov-mobile.webp": 1076,
	"./campaigns/fa-cm2024-instructor-iliya-valchanov.webp": 1077,
	"./campaigns/fa-cm2024-instructor-ivan-kitov-mobile.webp": 1078,
	"./campaigns/fa-cm2024-instructor-ivan-kitov.webp": 1079,
	"./campaigns/fa-cm2024-instructor-ivan-vaptsarov-mobile.webp": 1080,
	"./campaigns/fa-cm2024-instructor-ivan-vaptsarov.webp": 1081,
	"./campaigns/fa-cm2024-instructor-martin-ganchev-mobile.webp": 1082,
	"./campaigns/fa-cm2024-instructor-martin-ganchev.webp": 1083,
	"./campaigns/fa-cm2024-instructor-ned-krastev-mobile.webp": 1084,
	"./campaigns/fa-cm2024-instructor-ned-krastev.webp": 1085,
	"./campaigns/fa-cm2024-instructor-peter-lipovyanov-mobile.webp": 1086,
	"./campaigns/fa-cm2024-instructor-peter-lipovyanov.webp": 1087,
	"./campaigns/fa-cm2024-instructor-randy-rosseel-mobile.webp": 1088,
	"./campaigns/fa-cm2024-instructor-randy-rosseel.webp": 1089,
	"./campaigns/fa-cm2024-instructor-valentina-bogdanova-mobile.webp": 1090,
	"./campaigns/fa-cm2024-instructor-valentina-bogdanova.webp": 1091,
	"./campaigns/fa-cm2024-projects.webp": 1092,
	"./campaigns/fa-cm2024-tracks.webp": 1093,
	"./campaigns/fa-cme-certificate.webp": 1094,
	"./campaigns/fa-cme-channels.webp": 1095,
	"./campaigns/fa-cme-clp.webp": 1096,
	"./campaigns/fa-cme-exams.webp": 1097,
	"./campaigns/fa-cme-leaderboard.webp": 1098,
	"./campaigns/fa-cme-projects.webp": 1099,
	"./campaigns/fa-cme-resume.webp": 1100,
	"./campaigns/fa-cme-tracks.webp": 1101,
	"./campaigns/fa-cme-xp.webp": 1102,
	"./campaigns/fa-cml2024-bg-bottom-banner-laptop.webp": 1103,
	"./campaigns/fa-cml2024-bg-bottom-banner-mobile.webp": 1104,
	"./campaigns/fa-cml2024-bg-bottom-banner.webp": 682,
	"./campaigns/fa-cml2024-bg-footer-mobile.webp": 1105,
	"./campaigns/fa-cml2024-bg-footer.webp": 1106,
	"./campaigns/fa-cml2024-bg-hero-laptop.webp": 1107,
	"./campaigns/fa-cml2024-bg-hero-mobile.webp": 1108,
	"./campaigns/fa-cml2024-bg-hero.webp": 1109,
	"./campaigns/fa-cml2024-certificates.webp": 1110,
	"./campaigns/fa-cml2024-clp.webp": 1111,
	"./campaigns/fa-cml2024-exams.webp": 1112,
	"./campaigns/fa-cml2024-exercises.webp": 1113,
	"./campaigns/fa-cml2024-hero-stamp.webp": 683,
	"./campaigns/fa-cml2024-instructor-antoniya-baltova-mobile.webp": 1114,
	"./campaigns/fa-cml2024-instructor-antoniya-baltova.webp": 1115,
	"./campaigns/fa-cml2024-instructor-gilbert-eijkelenboom-mobile.webp": 1116,
	"./campaigns/fa-cml2024-instructor-gilbert-eijkelenboom.webp": 1117,
	"./campaigns/fa-cml2024-instructor-iliya-valchanov-mobile.webp": 1118,
	"./campaigns/fa-cml2024-instructor-iliya-valchanov.webp": 1119,
	"./campaigns/fa-cml2024-instructor-ivan-kitov-mobile.webp": 1120,
	"./campaigns/fa-cml2024-instructor-ivan-kitov.webp": 1121,
	"./campaigns/fa-cml2024-instructor-ivan-vaptsarov-mobile.webp": 1122,
	"./campaigns/fa-cml2024-instructor-ivan-vaptsarov.webp": 1123,
	"./campaigns/fa-cml2024-instructor-martin-ganchev-mobile.webp": 1124,
	"./campaigns/fa-cml2024-instructor-martin-ganchev.webp": 1125,
	"./campaigns/fa-cml2024-instructor-ned-krastev-mobile.webp": 1126,
	"./campaigns/fa-cml2024-instructor-ned-krastev.webp": 1127,
	"./campaigns/fa-cml2024-instructor-peter-lipovyanov-mobile.webp": 1128,
	"./campaigns/fa-cml2024-instructor-peter-lipovyanov.webp": 1129,
	"./campaigns/fa-cml2024-instructor-randy-rosseel-mobile.webp": 1130,
	"./campaigns/fa-cml2024-instructor-randy-rosseel.webp": 1131,
	"./campaigns/fa-cml2024-instructor-valentina-bogdanova-mobile.webp": 1132,
	"./campaigns/fa-cml2024-instructor-valentina-bogdanova.webp": 1133,
	"./campaigns/fa-cml2024-projects.webp": 1134,
	"./campaigns/fa-cml2024-tracks.webp": 1135,
	"./campaigns/fa-ft2024-bg-footer-mobile.webp": 1136,
	"./campaigns/fa-ft2024-bg-footer.webp": 1137,
	"./campaigns/fa-ft2024-bg-hero-mobile.webp": 1138,
	"./campaigns/fa-ft2024-bg-hero.webp": 1139,
	"./campaigns/fa-ft2024-certificate.webp": 1140,
	"./campaigns/fa-ft2024-channels.webp": 1141,
	"./campaigns/fa-ft2024-clp.webp": 1142,
	"./campaigns/fa-ft2024-exams.webp": 1143,
	"./campaigns/fa-ft2024-hero-stamp.webp": 684,
	"./campaigns/fa-ft2024-leaderboard.webp": 1144,
	"./campaigns/fa-ft2024-projects.webp": 1145,
	"./campaigns/fa-ft2024-resume.webp": 1146,
	"./campaigns/fa-ft2024-tracks.webp": 1147,
	"./campaigns/fa-ft2024-xp.webp": 1148,
	"./campaigns/fa-fw-bg-bottom-banner.webp": 685,
	"./campaigns/fa-fw-bg-footer-final.webp": 1149,
	"./campaigns/fa-fw-bg-footer-mobile-final.webp": 1150,
	"./campaigns/fa-fw-bg-hero-mobile-final.webp": 1151,
	"./campaigns/fa-fw-bg-hero.webp": 1152,
	"./campaigns/fa-fw-certificate.webp": 1153,
	"./campaigns/fa-fw-channels.webp": 1154,
	"./campaigns/fa-fw-clp.webp": 1155,
	"./campaigns/fa-fw-exams.webp": 1156,
	"./campaigns/fa-fw-leaderboard.webp": 1157,
	"./campaigns/fa-fw-projects.webp": 1158,
	"./campaigns/fa-fw-resume.webp": 1159,
	"./campaigns/fa-fw-tracks.webp": 1160,
	"./campaigns/fa-fw-xp.webp": 1161,
	"./campaigns/fa-fw2024-bg-bottom-banner.webp": 686,
	"./campaigns/fa-fw2024-bg-btn-laptop.webp": 1162,
	"./campaigns/fa-fw2024-bg-btn-mobile.webp": 1163,
	"./campaigns/fa-fw2024-bg-btn.webp": 1164,
	"./campaigns/fa-fw2024-bg-footer-laptop.webp": 1165,
	"./campaigns/fa-fw2024-bg-footer-mobile.webp": 1166,
	"./campaigns/fa-fw2024-bg-footer.webp": 1167,
	"./campaigns/fa-fw2024-bg-hero-laptop.webp": 1168,
	"./campaigns/fa-fw2024-bg-hero-mobile.webp": 1169,
	"./campaigns/fa-fw2024-bg-hero.webp": 1170,
	"./campaigns/fa-fw2024-certificates.webp": 1171,
	"./campaigns/fa-fw2024-clp.webp": 1172,
	"./campaigns/fa-fw2024-exams.webp": 1173,
	"./campaigns/fa-fw2024-exercises-new.webp": 1174,
	"./campaigns/fa-fw2024-exercises.webp": 1175,
	"./campaigns/fa-fw2024-projects.webp": 1176,
	"./campaigns/fa-fw2024-tracks.webp": 1177,
	"./campaigns/fa-js2025-bg-bottom-banner-laptop.webp": 1178,
	"./campaigns/fa-js2025-bg-bottom-banner.webp": 1179,
	"./campaigns/fa-js2025-bg-footer-mobile.webp": 1180,
	"./campaigns/fa-js2025-bg-footer.webp": 1181,
	"./campaigns/fa-js2025-bg-hero-mobile.webp": 1182,
	"./campaigns/fa-js2025-bg-hero.webp": 1183,
	"./campaigns/fa-js2025-certificates.webp": 1184,
	"./campaigns/fa-js2025-clp.webp": 1185,
	"./campaigns/fa-js2025-exams.webp": 1186,
	"./campaigns/fa-js2025-exercises.webp": 1187,
	"./campaigns/fa-js2025-instructor-antoniya-baltova-mobile.webp": 1188,
	"./campaigns/fa-js2025-instructor-antoniya-baltova.webp": 1189,
	"./campaigns/fa-js2025-instructor-gilbert-eijkelenboom-mobile.webp": 1190,
	"./campaigns/fa-js2025-instructor-gilbert-eijkelenboom.webp": 1191,
	"./campaigns/fa-js2025-instructor-iliya-valchanov-mobile.webp": 1192,
	"./campaigns/fa-js2025-instructor-iliya-valchanov.webp": 1193,
	"./campaigns/fa-js2025-instructor-ivan-kitov-mobile.webp": 1194,
	"./campaigns/fa-js2025-instructor-ivan-kitov.webp": 1195,
	"./campaigns/fa-js2025-instructor-ivan-vaptsarov-mobile.webp": 1196,
	"./campaigns/fa-js2025-instructor-ivan-vaptsarov.webp": 1197,
	"./campaigns/fa-js2025-instructor-martin-ganchev-mobile.webp": 1198,
	"./campaigns/fa-js2025-instructor-martin-ganchev.webp": 1199,
	"./campaigns/fa-js2025-instructor-ned-krastev-mobile.webp": 1200,
	"./campaigns/fa-js2025-instructor-ned-krastev.webp": 1201,
	"./campaigns/fa-js2025-instructor-peter-lipovyanov-mobile.webp": 1202,
	"./campaigns/fa-js2025-instructor-peter-lipovyanov.webp": 1203,
	"./campaigns/fa-js2025-instructor-randy-rosseel-mobile.webp": 1204,
	"./campaigns/fa-js2025-instructor-randy-rosseel.webp": 1205,
	"./campaigns/fa-js2025-instructor-valentina-bogdanova-mobile.webp": 1206,
	"./campaigns/fa-js2025-instructor-valentina-bogdanova.webp": 1207,
	"./campaigns/fa-js2025-projects.webp": 1208,
	"./campaigns/fa-js2025-tracks.webp": 1209,
	"./campaigns/fa-lf-bg-bottom-banner-mobile.webp": 1210,
	"./campaigns/fa-lf-bg-bottom-banner.webp": 687,
	"./campaigns/fa-lf-bg-footer-mobile.webp": 1211,
	"./campaigns/fa-lf-bg-footer.webp": 1212,
	"./campaigns/fa-lf-bg-hero-mobile.webp": 1213,
	"./campaigns/fa-lf-bg-hero.webp": 1214,
	"./campaigns/fa-lf-certification.webp": 688,
	"./campaigns/fa-lf-hero-stamp.webp": 689,
	"./campaigns/fa-lf-instructor-antoniya-baltova-mobile.webp": 690,
	"./campaigns/fa-lf-instructor-antoniya-baltova.webp": 691,
	"./campaigns/fa-lf-instructor-gilbert-eijkelenboom-mobile.webp": 692,
	"./campaigns/fa-lf-instructor-gilbert-eijkelenboom.webp": 693,
	"./campaigns/fa-lf-instructor-iliya-valchanov-mobile.webp": 694,
	"./campaigns/fa-lf-instructor-iliya-valchanov.webp": 695,
	"./campaigns/fa-lf-instructor-ivan-kitov-mobile.webp": 696,
	"./campaigns/fa-lf-instructor-ivan-kitov.webp": 697,
	"./campaigns/fa-lf-instructor-ivan-vaptsarov-mobile.webp": 698,
	"./campaigns/fa-lf-instructor-ivan-vaptsarov.webp": 699,
	"./campaigns/fa-lf-instructor-martin-ganchev-mobile.webp": 700,
	"./campaigns/fa-lf-instructor-martin-ganchev.webp": 701,
	"./campaigns/fa-lf-instructor-ned-krastev-mobile.webp": 702,
	"./campaigns/fa-lf-instructor-ned-krastev.webp": 703,
	"./campaigns/fa-lf-instructor-peter-lipovyanov-mobile.webp": 704,
	"./campaigns/fa-lf-instructor-peter-lipovyanov.webp": 705,
	"./campaigns/fa-lf-instructor-randy-rosseel-mobile.webp": 706,
	"./campaigns/fa-lf-instructor-randy-rosseel.webp": 707,
	"./campaigns/fa-lf-instructor-valentina-bogdanova-mobile.webp": 708,
	"./campaigns/fa-lf-instructor-valentina-bogdanova.webp": 709,
	"./campaigns/fa-mw-bg-bottom-banner.webp": 710,
	"./campaigns/fa-mw-bg-footer-mobile.webp": 1215,
	"./campaigns/fa-mw-bg-footer.webp": 1216,
	"./campaigns/fa-mw-bg-hero-mobile.webp": 1217,
	"./campaigns/fa-mw-bg-hero.webp": 1218,
	"./campaigns/fa-mw-certificate.webp": 1219,
	"./campaigns/fa-mw-channels.webp": 1220,
	"./campaigns/fa-mw-clp.webp": 1221,
	"./campaigns/fa-mw-exams.webp": 1222,
	"./campaigns/fa-mw-hero-stamp.webp": 711,
	"./campaigns/fa-mw-leaderboard.webp": 1223,
	"./campaigns/fa-mw-projects.webp": 1224,
	"./campaigns/fa-mw-resume.webp": 1225,
	"./campaigns/fa-mw-tracks.webp": 1226,
	"./campaigns/fa-mw-xp.webp": 1227,
	"./campaigns/fa-oth-bg-bottom-banner.webp": 712,
	"./campaigns/fa-oth-bg-hero-mobile.webp": 1228,
	"./campaigns/fa-oth-bg-hero.webp": 1229,
	"./campaigns/fa-oth-certificate.webp": 1230,
	"./campaigns/fa-oth-channels.webp": 1231,
	"./campaigns/fa-oth-clp.webp": 1232,
	"./campaigns/fa-oth-exams.webp": 1233,
	"./campaigns/fa-oth-leaderboard.webp": 1234,
	"./campaigns/fa-oth-projects.webp": 1235,
	"./campaigns/fa-oth-resume.webp": 1236,
	"./campaigns/fa-oth-tracks.webp": 1237,
	"./campaigns/fa-oth-xp.webp": 1238,
	"./campaigns/fa-tyf-bg-bottom-banner.webp": 1239,
	"./campaigns/fa-tyf-bg-footer-mobile.webp": 1240,
	"./campaigns/fa-tyf-bg-footer.webp": 1241,
	"./campaigns/fa-tyf-bg-hero-mobile.webp": 1242,
	"./campaigns/fa-tyf-bg-hero.webp": 1243,
	"./campaigns/fa-tyf-certificate.webp": 1244,
	"./campaigns/fa-tyf-channels.webp": 1245,
	"./campaigns/fa-tyf-clp.webp": 1246,
	"./campaigns/fa-tyf-exams.webp": 1247,
	"./campaigns/fa-tyf-leaderboard.webp": 1248,
	"./campaigns/fa-tyf-projects.webp": 1249,
	"./campaigns/fa-tyf-resume.webp": 1250,
	"./campaigns/fa-tyf-tracks.webp": 1251,
	"./campaigns/fa-tyf-xp.webp": 1252,
	"./campaigns/finance-courses-offer-landing/fc-card-bg.png": 1537,
	"./campaigns/finance-courses-offer-landing/fc-cards.jpg": 1538,
	"./campaigns/finance-courses-offer-landing/fc-career-tracks.jpg": 1539,
	"./campaigns/finance-courses-offer-landing/fc-certificates.jpg": 1540,
	"./campaigns/finance-courses-offer-landing/fc-coins.jpg": 1541,
	"./campaigns/finance-courses-offer-landing/fc-exams.jpg": 1542,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg-mobile.png": 1543,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg.jpg": 1544,
	"./campaigns/finance-courses-offer-landing/fc-footer-bottom.jpg": 1545,
	"./campaigns/finance-courses-offer-landing/fc-footer-top.png": 1546,
	"./campaigns/finance-courses-offer-landing/fc-leaderboard.jpg": 1547,
	"./campaigns/finance-courses-offer-landing/fc-newsfeed.jpg": 1548,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-bg.jpg": 1549,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-mobile-bg.png": 1550,
	"./campaigns/finance-courses-offer-landing/fc-streaks.jpg": 1551,
	"./campaigns/finance-courses-offer-landing/fc-video-bg.jpg": 1552,
	"./campaigns/finance-courses-offer-landing/fc-xp.jpg": 1553,
	"./campaigns/finance-courses-offer-landing/hero-bg1-mobile.png": 1554,
	"./campaigns/finance-courses-offer-landing/hero-bg2-mobile.png": 1555,
	"./campaigns/future-proof/c-fpc-cards.webp": 1253,
	"./campaigns/future-proof/c-fpc-certificates.webp": 1254,
	"./campaigns/future-proof/c-fpc-exams.webp": 1255,
	"./campaigns/future-proof/c-fpc-leaderboard.webp": 1256,
	"./campaigns/future-proof/c-fpc-tracks.webp": 1257,
	"./campaigns/future-proof/c-fpc-xp.webp": 1258,
	"./campaigns/future-proof/fpc-bg-bottom-banner.webp": 1259,
	"./campaigns/future-proof/fpc-bg-footer-mobile.webp": 1260,
	"./campaigns/future-proof/fpc-bg-footer.webp": 1261,
	"./campaigns/future-proof/fpc-bg-hero-mobile.webp": 1262,
	"./campaigns/future-proof/fpc-bg-hero.webp": 1263,
	"./campaigns/future-proof/fpc-proof-bg-blog.webp": 1264,
	"./campaigns/get-future-ready/dsgfr-bg-blog.webp": 1265,
	"./campaigns/get-future-ready/dsgfr-bg-bottom-banner.webp": 1266,
	"./campaigns/get-future-ready/dsgfr-bg-footer-mobile.webp": 1267,
	"./campaigns/get-future-ready/dsgfr-bg-footer.webp": 1268,
	"./campaigns/get-future-ready/dsgfr-bg-hero-mobile.webp": 1269,
	"./campaigns/get-future-ready/dsgfr-bg-hero.webp": 1270,
	"./campaigns/get-future-ready/dsgfr-certificate.webp": 1271,
	"./campaigns/get-future-ready/dsgfr-channels.webp": 1272,
	"./campaigns/get-future-ready/dsgfr-clp.webp": 1273,
	"./campaigns/get-future-ready/dsgfr-exams.webp": 1274,
	"./campaigns/get-future-ready/dsgfr-leaderboard.webp": 1275,
	"./campaigns/get-future-ready/dsgfr-projects.webp": 1276,
	"./campaigns/get-future-ready/dsgfr-resume.webp": 1277,
	"./campaigns/get-future-ready/dsgfr-technologies-mobile.webp": 1278,
	"./campaigns/get-future-ready/dsgfr-technologies.webp": 1279,
	"./campaigns/get-future-ready/dsgfr-tracks.webp": 1280,
	"./campaigns/get-future-ready/dsgfr-xp.webp": 1281,
	"./campaigns/get-future-ready/gfr-bg-bottom-banner.webp": 1282,
	"./campaigns/get-future-ready/gfr-bg-footer-mobile-new.webp": 1283,
	"./campaigns/get-future-ready/gfr-bg-footer.webp": 1284,
	"./campaigns/get-future-ready/gfr-bg-hero-mobile.webp": 1285,
	"./campaigns/get-future-ready/gfr-bg-hero.webp": 1286,
	"./campaigns/get-future-ready/gfr-cards.webp": 1287,
	"./campaigns/get-future-ready/gfr-certificate.webp": 1288,
	"./campaigns/get-future-ready/gfr-channels.webp": 1289,
	"./campaigns/get-future-ready/gfr-clp.webp": 1290,
	"./campaigns/get-future-ready/gfr-coins.webp": 1291,
	"./campaigns/get-future-ready/gfr-exams.webp": 1292,
	"./campaigns/get-future-ready/gfr-leaderboard.webp": 1293,
	"./campaigns/get-future-ready/gfr-projects.webp": 1294,
	"./campaigns/get-future-ready/gfr-streak.webp": 1295,
	"./campaigns/get-future-ready/gfr-tracks.webp": 1296,
	"./campaigns/get-future-ready/gfr-xp.webp": 1297,
	"./campaigns/got-what-it-takes-landing/gwt-blog-banner-bg.jpg": 1556,
	"./campaigns/got-what-it-takes-landing/gwt-cards.jpg": 1557,
	"./campaigns/got-what-it-takes-landing/gwt-career-tracks.jpg": 1558,
	"./campaigns/got-what-it-takes-landing/gwt-certificates.jpg": 1559,
	"./campaigns/got-what-it-takes-landing/gwt-exams.jpg": 1560,
	"./campaigns/got-what-it-takes-landing/gwt-leaderboard.jpg": 1561,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-background.jpg": 1562,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-mobile-bg.jpg": 1563,
	"./campaigns/got-what-it-takes-landing/gwt-sticky-banner.jpg": 1564,
	"./campaigns/got-what-it-takes-landing/gwt-xp-coins.jpg": 1565,
	"./campaigns/instructors/instr-anastasia.jpg": 1441,
	"./campaigns/instructors/instr-andrew.jpg": 1442,
	"./campaigns/instructors/instr-bernard.jpg": 1443,
	"./campaigns/instructors/instr-danielle.jpg": 1444,
	"./campaigns/instructors/instr-davis.jpg": 1445,
	"./campaigns/instructors/instr-elitsa.jpg": 1446,
	"./campaigns/instructors/instr-giles.jpg": 1447,
	"./campaigns/instructors/instr-harpreet.jpg": 1448,
	"./campaigns/instructors/instr-ken.jpg": 1449,
	"./campaigns/instructors/instr-olivier.jpg": 1450,
	"./campaigns/instructors/instr-randy.jpg": 1451,
	"./campaigns/instructors/instr-tina.jpg": 1452,
	"./campaigns/jumpstart-2023-landing/js-cards.jpg": 1566,
	"./campaigns/jumpstart-2023-landing/js-career-tracks.jpg": 1567,
	"./campaigns/jumpstart-2023-landing/js-certificates.jpg": 1568,
	"./campaigns/jumpstart-2023-landing/js-exams.jpg": 1569,
	"./campaigns/jumpstart-2023-landing/js-leaderboard.jpg": 1570,
	"./campaigns/jumpstart-2023-landing/js-xp-coins.jpg": 1571,
	"./campaigns/jumpstart-2023-landing/jumpstart-blog-banner.jpg": 1572,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg-mobile.png": 1573,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg.jpg": 1574,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg-mobile.png": 1575,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg.jpg": 1576,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg-1920.jpg": 1577,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg.jpg": 1578,
	"./campaigns/jumpstart-2023-landing/lightning-mobile.png": 1579,
	"./campaigns/jumpstart-2023-landing/lightning.png": 1580,
	"./campaigns/one-of-200-landing/oth-blog-banner-bg.jpg": 1581,
	"./campaigns/one-of-200-landing/oth-cards.jpg": 1582,
	"./campaigns/one-of-200-landing/oth-career-tracks.jpg": 1583,
	"./campaigns/one-of-200-landing/oth-certificates.jpg": 1584,
	"./campaigns/one-of-200-landing/oth-exams.jpg": 1585,
	"./campaigns/one-of-200-landing/oth-leaderboard.jpg": 1586,
	"./campaigns/one-of-200-landing/oth-sticky-banner-bg.jpg": 1587,
	"./campaigns/one-of-200-landing/oth-xp-coins.jpg": 1588,
	"./campaigns/top-finance-training/lightning2-mobile.jpg": 1589,
	"./campaigns/top-finance-training/lightning2.jpg": 1590,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop-last-promo.webp": 1298,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop.webp": 1299,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-last-promo.webp": 1300,
	"./campaigns/top-finance-training/tft-bottom-banner-bg.webp": 1301,
	"./campaigns/top-finance-training/tft-cards.webp": 1302,
	"./campaigns/top-finance-training/tft-certificates.webp": 1303,
	"./campaigns/top-finance-training/tft-coins.webp": 1304,
	"./campaigns/top-finance-training/tft-exams.webp": 1305,
	"./campaigns/top-finance-training/tft-footer-bg-mobile.webp": 1306,
	"./campaigns/top-finance-training/tft-footer-bg.jpg": 1591,
	"./campaigns/top-finance-training/tft-hero-bg.jpg": 1592,
	"./campaigns/top-finance-training/tft-hero-mobile-bg.webp": 1307,
	"./campaigns/top-finance-training/tft-leaderboard.webp": 1308,
	"./campaigns/top-finance-training/tft-newsfeed.webp": 1309,
	"./campaigns/top-finance-training/tft-streaks.webp": 1310,
	"./campaigns/top-finance-training/tft-tracks.webp": 1311,
	"./campaigns/top-finance-training/tft-xp-levels.webp": 1312,
	"./career-track-certificate.png": 3840,
	"./certificate-of-completion.png": 4324,
	"./cfi.jpg": 4325,
	"./codecademy.jpg": 4326,
	"./contacts.png": 3849,
	"./corporate-training/adasci.webp": 3873,
	"./corporate-training/aehea.webp": 3872,
	"./corporate-training/corporate-training-banner-mobile.webp": 4327,
	"./corporate-training/corporate-training-banner.webp": 4328,
	"./corporate-training/elqn.webp": 3871,
	"./corporate-training/gaote.webp": 3874,
	"./corporate-training/hero-corporate-training-mobile.webp": 4329,
	"./corporate-training/hero-corporate-training.webp": 4330,
	"./corporate-training/instructor-anastasia-kuznetsova-mobile.webp": 3737,
	"./corporate-training/instructor-anastasia-kuznetsova.webp": 3854,
	"./corporate-training/instructor-andrew-treadway-mobile.webp": 3738,
	"./corporate-training/instructor-andrew-treadway.webp": 3855,
	"./corporate-training/instructor-bernard-marr-mobile.webp": 3739,
	"./corporate-training/instructor-bernard-marr.webp": 3856,
	"./corporate-training/instructor-danielle-the-mobile.webp": 3740,
	"./corporate-training/instructor-danielle-the.webp": 3857,
	"./corporate-training/instructor-davis-balaba-mobile.webp": 3741,
	"./corporate-training/instructor-davis-balaba.webp": 3858,
	"./corporate-training/instructor-harpreet-sahota-mobile.webp": 3742,
	"./corporate-training/instructor-harpreet-sahota.webp": 3859,
	"./corporate-training/instructor-horia-margarit-mobile.webp": 3743,
	"./corporate-training/instructor-horia-margarit.webp": 3860,
	"./corporate-training/instructor-jeff-li-mobile.webp": 3744,
	"./corporate-training/instructor-jeff-li.webp": 3861,
	"./corporate-training/instructor-ken-jee-mobile.webp": 3745,
	"./corporate-training/instructor-ken-jee.webp": 3862,
	"./corporate-training/instructor-lauren-newbould-mobile.webp": 3746,
	"./corporate-training/instructor-lauren-newbould.webp": 3863,
	"./corporate-training/instructor-olivier-maugain-mobile.webp": 3747,
	"./corporate-training/instructor-olivier-maugain.webp": 3864,
	"./corporate-training/instructor-rahul-singh-47-mobile.webp": 3748,
	"./corporate-training/instructor-rahul-singh-47.webp": 3865,
	"./corporate-training/instructor-randy-rosseel-mobile.webp": 3749,
	"./corporate-training/instructor-randy-rosseel.webp": 3866,
	"./corporate-training/instructor-shashank-kalanithi-mobile.webp": 3750,
	"./corporate-training/instructor-shashank-kalanithi.webp": 3867,
	"./corporate-training/instructor-tina-huang-mobile.webp": 3751,
	"./corporate-training/instructor-tina-huang.webp": 3868,
	"./corporate-training/point-middle.png": 3736,
	"./corporate-training/point-start.png": 3735,
	"./corporate-training/points-with-lines.png": 3850,
	"./corporate-training/testimonial-lee-mcfarling.webp": 3851,
	"./corporate-training/testimonial-veronika-konecna.webp": 3852,
	"./corporate-training/testimonial-yuvraj-shivaji-dhepe.webp": 3853,
	"./corporate-training/users-group-hovered.png": 3870,
	"./corporate-training/users-group.png": 3869,
	"./course-library.png": 4331,
	"./course-preview.jpg": 4332,
	"./coursera-img2.jpg": 4333,
	"./courses-banner-mobile.jpg": 4334,
	"./courses-banner.jpg": 4335,
	"./data-camp-comparison.png": 4336,
	"./data-camp-img1-fa.jpg": 4337,
	"./data-camp-img1.jpg": 4338,
	"./data-camp-img2.jpg": 4339,
	"./data-science-fundamentals.png": 4340,
	"./data-science-vs-datacamp.png": 4341,
	"./datacamp-alternative-365-certificate.png": 4342,
	"./datacamp-comparison.png": 4343,
	"./datacamp.jpg": 4344,
	"./dataquest-courses.png": 4345,
	"./dataquest-img2.jpg": 4346,
	"./dataquest-vs-365datascience-courses.jpg": 4347,
	"./dataquest.jpg": 4348,
	"./discover-author_Elitsa.jpg": 4349,
	"./discover-author_Iliya.jpg": 4350,
	"./discover-author_Martin.jpg": 4351,
	"./discover-author_Ned.jpg": 4352,
	"./discover-student_Ah_Lam.jpg": 4353,
	"./discover-student_Anuj_Gupta.jpg": 4354,
	"./discover-student_Goodwin_Akpan.jpg": 4355,
	"./discover-student_Harshita_Sharma.jpg": 4356,
	"./discover-student_José_Alvarez.jpg": 4357,
	"./discover-student_Karen_Ann.jpg": 4358,
	"./discover-student_Maher_Nabeel.jpg": 4359,
	"./discover-student_Michael_Erlihson.jpg": 4360,
	"./discover-student_Richard_Banks.jpg": 4361,
	"./discover-student_Vikesh_Reddy.jpg": 4362,
	"./discover-student_Wilma_Berg.jpg": 4363,
	"./ds-pre-footer-projects.webp": 4364,
	"./ds-signup-bg-v2-laptop.webp": 4365,
	"./ds-signup-bg-v2-mobile-new.webp": 4366,
	"./ds-signup-bg-v2-mobile.webp": 4367,
	"./ds-signup-bg-v2-prefooter-laptop.webp": 4368,
	"./ds-signup-bg-v2-prefooter-mobile-new.webp": 4369,
	"./ds-signup-bg-v2-prefooter-mobile.webp": 4370,
	"./ds-signup-bg-v2-prefooter.webp": 4371,
	"./ds-signup-bg-v2.webp": 4372,
	"./ds-signup-bg.webp": 3032,
	"./edx.jpg": 4373,
	"./fa-footer-reviews-testimonials-page-mobile.webp": 4374,
	"./fa-footer-reviews-testimonials-page.webp": 4375,
	"./fa-hero-testimonials-page-reviews-mobile.webp": 4376,
	"./fa-hero-testimonials-page-reviews.webp": 4377,
	"./fa-landing-testimonials-mobile.webp": 3539,
	"./fa-landing-testimonials.webp": 3540,
	"./fa-signup-bg-v2-laptop.webp": 4378,
	"./fa-signup-bg-v2-mobile-new.webp": 4379,
	"./fa-signup-bg-v2-mobile.webp": 4380,
	"./fa-signup-bg-v2-prefooter-laptop.webp": 4381,
	"./fa-signup-bg-v2-prefooter-mobile-new.webp": 4382,
	"./fa-signup-bg-v2-prefooter-mobile.webp": 4383,
	"./fa-signup-bg-v2-prefooter.webp": 4384,
	"./fa-signup-bg-v2.webp": 4385,
	"./fa-signup-master-v2.webp": 3538,
	"./fa/fa-365-logo-small.png": 4067,
	"./fa/fa-about-us-2.jpg": 4386,
	"./fa/fa-about-us-our-vision.jpg": 3809,
	"./fa/fa-about-us.jpg": 4387,
	"./fa/fa-b2b-img1.png": 3827,
	"./fa/fa-b2b-img2.png": 3828,
	"./fa/fa-b2b-img3.png": 3829,
	"./fa/fa-b2b-img4.png": 3830,
	"./fa/fa-b2b-img5.png": 3831,
	"./fa/fa-b2b-img6.png": 3832,
	"./fa/fa-b2b-preview-image-mobile.jpg": 3825,
	"./fa/fa-b2b-preview-image.jpg": 3823,
	"./fa/fa-career-track-certificate.png": 3839,
	"./fa/fa-contacts.jpg": 3848,
	"./fa/fa-courses-banner-mobile.jpg": 4388,
	"./fa/fa-courses-banner.jpg": 4389,
	"./fa/fa-guidelines-wall.jpg": 4390,
	"./fa/fa-homepage-hero-image.webp": 4391,
	"./fa/fa-landing/fa-business-group-waving.webp": 2163,
	"./fa/fa-landing/fa-city-shadows-mobile.jpg": 4068,
	"./fa/fa-landing/fa-city-shadows.jpg": 4069,
	"./fa/fa-landing/fa-free-offer-upgrade-bg.jpg": 4070,
	"./fa/fa-landing/fa-free-offer-upgrade-mobile-bg.jpg": 4071,
	"./fa/fa-landing/fa-platform-snaps-mobile.png": 3688,
	"./fa/fa-landing/fa-platform-snaps.png": 3689,
	"./fa/fa-landing/fa-resources-center-offer-bg.jpg": 4072,
	"./fa/fa-landing/fa-resources-center-offer-mobile-bg.jpg": 4073,
	"./fa/fa-landing/fa-signup-mobile.jpg": 4074,
	"./fa/fa-landing/fa-start-learning-bg.jpg": 4075,
	"./fa/fa-landing/fa-start-learning-m-bg.jpg": 4076,
	"./fa/fa-landing/fa-start-learning-m-mobile-bg.jpg": 4077,
	"./fa/fa-landing/fa-start-learning-mobile-bg.jpg": 4078,
	"./fa/fa-landing/fa-students-reviews.png": 3504,
	"./fa/fa-login-bg.jpg": 4392,
	"./fa/fa-pre-footer-homepage.jpg": 4393,
	"./fa/fa-pre-footer-homepage.webp": 4394,
	"./fa/fa-pre-footer-projects.webp": 4395,
	"./fa/fa-pre-footer.webp": 1469,
	"./fa/fa-signup-bg.jpg": 4396,
	"./fa/fa-signup-bg.webp": 3031,
	"./fa/fa-signup-users.png": 3918,
	"./fa/fa-something-better-bg.jpg": 4397,
	"./fa/fa-you-missed-it-bg.jpg": 4398,
	"./facebook_open_graph.png": 4399,
	"./first-place.png": 4400,
	"./flashcards-banner.jpg": 4401,
	"./footer-reviews-testimonials-page-mobile.webp": 4402,
	"./footer-reviews-testimonials-page.webp": 4403,
	"./for-business-block.png": 4404,
	"./founder-image.png": 4079,
	"./founder-sign.png": 4080,
	"./free-data-science-month.jpg": 4405,
	"./globuses.png": 4406,
	"./guidelines-mobile.jpg": 4407,
	"./guidelines-wall.jpg": 4408,
	"./hero-campaign-banner-bg.jpg": 4409,
	"./hero-campaign-bg-mobile.jpg": 4410,
	"./hero-campaign-bg.jpg": 4411,
	"./hero-testimonials-page-reviews-mobile.webp": 4412,
	"./hero-testimonials-page-reviews.webp": 4413,
	"./hero-testimonials.jpg": 4414,
	"./home-bg-hero.webp": 4415,
	"./home-v2-bg-hero-mobile.webp": 4416,
	"./home-v2-bg-hero.webp": 4417,
	"./icon-chart-blur.png": 1629,
	"./icon-lp-coin.png": 4081,
	"./icon-python-calc.png": 2040,
	"./icon-python-site.png": 4082,
	"./icon-quote-testimonial-story.png": 4418,
	"./icon-quote-testimonials.png": 4419,
	"./icon-quotes.png": 4420,
	"./icon-r-calc.png": 2041,
	"./icon-r.png": 1628,
	"./icon-video-cc.png": 4421,
	"./interview/interview-hero-img-2.webp": 3752,
	"./interview/interview-hero-img.png": 4422,
	"./interview/interview-hero-landing.png": 4423,
	"./interview/interview-hero-mobile.png": 4424,
	"./interview/interview-laptop-any-job.webp": 3757,
	"./interview/interview-laptop-compiler.webp": 3758,
	"./interview/interview-laptop-hr.webp": 3755,
	"./interview/interview-laptop-result-cut.webp": 3759,
	"./interview/interview-laptop-result.webp": 3890,
	"./interview/interview-laptop-technical.webp": 3756,
	"./interview/interview-laptop-web.webp": 3891,
	"./interview/interview-laptop.webp": 3525,
	"./interview/interview-techs-2.webp": 3892,
	"./interview/interview-techs.png": 4425,
	"./interview/logos/interview-AT&T-2.svg": 4426,
	"./interview/logos/interview-Accenture-2.svg": 4427,
	"./interview/logos/interview-Airbnb-2.svg": 4428,
	"./interview/logos/interview-Amazon-2.svg": 3667,
	"./interview/logos/interview-Amazon_Web_Services-2.svg": 3658,
	"./interview/logos/interview-American_express-2.svg": 3672,
	"./interview/logos/interview-Apple-2.svg": 4429,
	"./interview/logos/interview-Bank_of_America-2.svg": 3659,
	"./interview/logos/interview-Bayer-2.svg": 4430,
	"./interview/logos/interview-Booz_Allen_Hamilton-2.svg": 3673,
	"./interview/logos/interview-Boston_Consulting_Group-2.svg": 3653,
	"./interview/logos/interview-Capgemini-2.svg": 4431,
	"./interview/logos/interview-Capital_one-2.svg": 3660,
	"./interview/logos/interview-Chevron-2.svg": 4432,
	"./interview/logos/interview-Cisco_Systems-2.svg": 3674,
	"./interview/logos/interview-Dell_Technologies-2.svg": 3654,
	"./interview/logos/interview-Deloitte-2.svg": 4433,
	"./interview/logos/interview-FedEx-2.svg": 4434,
	"./interview/logos/interview-Ford_Motor_Company-2.svg": 3668,
	"./interview/logos/interview-Glassdoor-2.svg": 4435,
	"./interview/logos/interview-Google-2.svg": 4436,
	"./interview/logos/interview-Guidehouse-2.svg": 3655,
	"./interview/logos/interview-HP-2.svg": 4437,
	"./interview/logos/interview-Humna-2.svg": 3669,
	"./interview/logos/interview-IBM-2.svg": 4438,
	"./interview/logos/interview-Indeed-2.svg": 4439,
	"./interview/logos/interview-Intel_Corporation-2.svg": 3656,
	"./interview/logos/interview-JPMorgan_Chase_and_Co-2.svg": 3661,
	"./interview/logos/interview-KPMG-2.svg": 4440,
	"./interview/logos/interview-Kaiser_Permanente-2.svg": 3670,
	"./interview/logos/interview-LinkedIn-2.svg": 4441,
	"./interview/logos/interview-McDonalds-2.svg": 3657,
	"./interview/logos/interview-McKinsey_and_Company-2.svg": 3662,
	"./interview/logos/interview-Meta-2.svg": 4442,
	"./interview/logos/interview-Microsoft-2.svg": 4443,
	"./interview/logos/interview-NVIDA-2.svg": 3663,
	"./interview/logos/interview-Nielsen-2.svg": 4444,
	"./interview/logos/interview-Nike-2.svg": 4445,
	"./interview/logos/interview-Optum-2.svg": 4446,
	"./interview/logos/interview-Paypal-2.svg": 4447,
	"./interview/logos/interview-PwC-2.svg": 4448,
	"./interview/logos/interview-SAP-2.svg": 4449,
	"./interview/logos/interview-Spotify-2.svg": 3664,
	"./interview/logos/interview-Starbucks-2.svg": 4450,
	"./interview/logos/interview-Starbucks2-2.svg": 4451,
	"./interview/logos/interview-T-Mobile-2.svg": 3665,
	"./interview/logos/interview-TIkTok-2.svg": 4452,
	"./interview/logos/interview-Target-2.svg": 4453,
	"./interview/logos/interview-UPS-2.svg": 4454,
	"./interview/logos/interview-Uber-2.svg": 4455,
	"./interview/logos/interview-UnitedHealth_Group-2.svg": 3675,
	"./interview/logos/interview-Visa-2.svg": 4456,
	"./interview/logos/interview-Walmart_Global_Tech-2.svg": 3666,
	"./interview/logos/interview-Walt_Disney_Company-2.svg": 3671,
	"./interview/techs-icons/ds-is-icon-python-scroll.webp": 3760,
	"./interview/techs-icons/ds-is-icon-r-scroll.webp": 3761,
	"./interview/techs-icons/ds-is-icon-sql-scroll.webp": 3762,
	"./interview/techs-icons/python-hero.webp": 3753,
	"./interview/techs-icons/python-talk-is-cheap.webp": 3893,
	"./interview/techs-icons/r-hero.webp": 3754,
	"./interview/techs-icons/r-talk-is-cheap.webp": 3894,
	"./interview/techs-icons/slqlite-talk-is-cheap.webp": 3895,
	"./join-bg.png": 4457,
	"./landing-page-bg.jpg": 4458,
	"./landing-page-mobile-bg.jpg": 4459,
	"./landing-page-resources-bg.jpg": 4460,
	"./landing-page-resources-mobile-bg.jpg": 4461,
	"./landing/ds-landing-bi-footer-mobile.webp": 3036,
	"./landing/ds-landing-bi-footer.webp": 3258,
	"./landing/ds-landing-bi-hero-mobile.webp": 3037,
	"./landing/ds-landing-bi-hero.webp": 3259,
	"./landing/ds-landing-bi-instructor-anastasia-kuznetsova-mobile.webp": 3038,
	"./landing/ds-landing-bi-instructor-anastasia-kuznetsova.webp": 3260,
	"./landing/ds-landing-bi-instructor-bernard-marr-mobile.webp": 3039,
	"./landing/ds-landing-bi-instructor-bernard-marr.webp": 3261,
	"./landing/ds-landing-bi-instructor-danielle-the-mobile.webp": 3040,
	"./landing/ds-landing-bi-instructor-danielle-the.webp": 3262,
	"./landing/ds-landing-bi-instructor-davis-balaba-mobile.webp": 3041,
	"./landing/ds-landing-bi-instructor-davis-balaba.webp": 3263,
	"./landing/ds-landing-bi-instructor-jeff-li-mobile.webp": 3042,
	"./landing/ds-landing-bi-instructor-jeff-li.webp": 3264,
	"./landing/ds-landing-bi-instructor-ken-jee-mobile.webp": 3043,
	"./landing/ds-landing-bi-instructor-ken-jee.webp": 3265,
	"./landing/ds-landing-bi-instructor-lauren-newbould-mobile.webp": 3044,
	"./landing/ds-landing-bi-instructor-lauren-newbould.webp": 3266,
	"./landing/ds-landing-bi-instructor-olivier-maugain-mobile.webp": 3045,
	"./landing/ds-landing-bi-instructor-olivier-maugain.webp": 3267,
	"./landing/ds-landing-bi-instructor-randy-rosseel-mobile.webp": 3046,
	"./landing/ds-landing-bi-instructor-randy-rosseel.webp": 3268,
	"./landing/ds-landing-bi-instructor-shashank-kalanithi-mobile.webp": 3047,
	"./landing/ds-landing-bi-instructor-shashank-kalanithi.webp": 3269,
	"./landing/ds-landing-bi-instructor-tina-huang-mobile.webp": 3048,
	"./landing/ds-landing-bi-instructor-tina-huang.webp": 3270,
	"./landing/ds-landing-bi-work-1.webp": 3230,
	"./landing/ds-landing-bi-work-2.webp": 3231,
	"./landing/ds-landing-bi-work-3.webp": 3232,
	"./landing/ds-landing-bi-work-4.webp": 3233,
	"./landing/fa-cfa-2-footer-mobile.webp": 3049,
	"./landing/fa-cfa-2-footer.webp": 3271,
	"./landing/fa-cfa-2-hero-mobile.webp": 3050,
	"./landing/fa-cfa-2-hero.webp": 3272,
	"./landing/fa-cfa-footer-mobile.webp": 3051,
	"./landing/fa-cfa-footer.webp": 3273,
	"./landing/fa-cfa-hero-mobile.webp": 3052,
	"./landing/fa-cfa-hero.webp": 3274,
	"./landing/fa-cfa-instructor-365-careers.webp": 3275,
	"./landing/fa-cfa-instructor-antoniya-baltova.webp": 3276,
	"./landing/fa-cfa-instructor-ivan-kitov.webp": 3277,
	"./landing/fa-cfa-instructor-nedko-krastev.webp": 3278,
	"./landing/fa-cfa-instructor-peter-lipovyanov.webp": 3279,
	"./landing/fa-cfa-review-1.webp": 3280,
	"./landing/fa-cfa-review-10.webp": 3281,
	"./landing/fa-cfa-review-2.webp": 3282,
	"./landing/fa-cfa-review-3.webp": 3283,
	"./landing/fa-cfa-review-4.webp": 3284,
	"./landing/fa-cfa-review-5.webp": 3285,
	"./landing/fa-cfa-review-6.webp": 3286,
	"./landing/fa-cfa-review-7.webp": 3287,
	"./landing/fa-cfa-review-8.webp": 3288,
	"./landing/fa-cfa-review-9.webp": 3289,
	"./landing/fa-cfa-stamp.webp": 2045,
	"./landing/fa-cfa-video-1.webp": 3290,
	"./landing/fa-cfa-video-2.webp": 3291,
	"./landing/fa-cfa-video-3.webp": 3292,
	"./landing/fa-cfa-video-4.webp": 3293,
	"./landing/fa-cfa-what-you-get-1.webp": 3294,
	"./landing/fa-cfa-what-you-get-2.webp": 3295,
	"./landing/fa-cfa-what-you-get-3.webp": 3296,
	"./landing/fa-cfa-what-you-get-4.webp": 3297,
	"./landing/fa-lp-sl-m-antoniya-baltova-mobile.webp": 3053,
	"./landing/fa-lp-sl-m-antoniya-baltova.webp": 3298,
	"./landing/fa-lp-sl-m-gilbert-eijkelenboom-mobile.webp": 3054,
	"./landing/fa-lp-sl-m-gilbert-eijkelenboom.webp": 3299,
	"./landing/fa-lp-sl-m-iliya-valchanov-mobile.webp": 3055,
	"./landing/fa-lp-sl-m-iliya-valchanov.webp": 3300,
	"./landing/fa-lp-sl-m-ivan-kitov-mobile.webp": 3056,
	"./landing/fa-lp-sl-m-ivan-kitov.webp": 3301,
	"./landing/fa-lp-sl-m-ivan-vaptsarov-mobile.webp": 3057,
	"./landing/fa-lp-sl-m-ivan-vaptsarov.webp": 3302,
	"./landing/fa-lp-sl-m-martin-ganchev-mobile.webp": 3058,
	"./landing/fa-lp-sl-m-martin-ganchev-new-mobile.webp": 3059,
	"./landing/fa-lp-sl-m-martin-ganchev-new.webp": 3303,
	"./landing/fa-lp-sl-m-martin-ganchev.webp": 3304,
	"./landing/fa-lp-sl-m-ned-krastev-mobile.webp": 3060,
	"./landing/fa-lp-sl-m-ned-krastev.webp": 3305,
	"./landing/fa-lp-sl-m-peter-lipovyanov-mobile.webp": 3061,
	"./landing/fa-lp-sl-m-peter-lipovyanov.webp": 3306,
	"./landing/fa-lp-sl-m-randy-rosseel-mobile.webp": 3062,
	"./landing/fa-lp-sl-m-randy-rosseel.webp": 3307,
	"./landing/fa-lp-sl-m-valentina-bogdanova-mobile.webp": 3063,
	"./landing/fa-lp-sl-m-valentina-bogdanova.webp": 3308,
	"./landing/lp-sl-m-anastasia-kuznetsova-mobile.webp": 2046,
	"./landing/lp-sl-m-anastasia-kuznetsova.webp": 3064,
	"./landing/lp-sl-m-bernard-marr-mobile.webp": 2047,
	"./landing/lp-sl-m-bernard-marr.webp": 3065,
	"./landing/lp-sl-m-bg-footer-mobile.webp": 2048,
	"./landing/lp-sl-m-bg-footer.webp": 3066,
	"./landing/lp-sl-m-bg-graduations-mobile.webp": 2049,
	"./landing/lp-sl-m-bg-graduations.webp": 3067,
	"./landing/lp-sl-m-bg-hero-mobile.webp": 2050,
	"./landing/lp-sl-m-bg-hero.webp": 3068,
	"./landing/lp-sl-m-bg-limited-offer-mobile.webp": 2051,
	"./landing/lp-sl-m-bg-limited-offer.webp": 3069,
	"./landing/lp-sl-m-bg-ribbon.webp": 3070,
	"./landing/lp-sl-m-bg-slider-mobile.webp": 2052,
	"./landing/lp-sl-m-bg-slider.webp": 3071,
	"./landing/lp-sl-m-danielle-the-mobile.webp": 2053,
	"./landing/lp-sl-m-danielle-the.webp": 3072,
	"./landing/lp-sl-m-davis-balaba-mobile.webp": 2054,
	"./landing/lp-sl-m-davis-balaba.webp": 3073,
	"./landing/lp-sl-m-jeff-li-1-mobile.webp": 2055,
	"./landing/lp-sl-m-jeff-li-1.webp": 3074,
	"./landing/lp-sl-m-ken-jee-mobile.webp": 2056,
	"./landing/lp-sl-m-ken-jee.webp": 3075,
	"./landing/lp-sl-m-lauren-newbould-1-mobile.webp": 2057,
	"./landing/lp-sl-m-lauren-newbould-1.webp": 3076,
	"./landing/lp-sl-m-master-mobile.webp": 2016,
	"./landing/lp-sl-m-master.webp": 2628,
	"./landing/lp-sl-m-olivier-maugain-mobile.webp": 2058,
	"./landing/lp-sl-m-olivier-maugain.webp": 3077,
	"./landing/lp-sl-m-randy-rosseel-mobile.webp": 2059,
	"./landing/lp-sl-m-randy-rosseel.webp": 3078,
	"./landing/lp-sl-m-shashank-kalanithi-1-mobile.webp": 2060,
	"./landing/lp-sl-m-shashank-kalanithi-1.webp": 3079,
	"./landing/lp-sl-m-tina-huang-mobile.webp": 2061,
	"./landing/lp-sl-m-tina-huang.webp": 3080,
	"./landing/lpage-cards-2.png": 4462,
	"./landing/lpage-career-tracks-2.png": 4463,
	"./landing/lpage-certificates-2.png": 4464,
	"./landing/lpage-coins-2.png": 4465,
	"./landing/lpage-exams-2.png": 4466,
	"./landing/lpage-leaderboard-2.png": 4467,
	"./landing/lpage-newsfeed-2.png": 4468,
	"./landing/lpage-streaks-2.png": 4469,
	"./landing/lpage-xp-levels-2.png": 4470,
	"./linkedIn-learning.jpg": 4471,
	"./live-trainings.jpg": 4472,
	"./login-bg.png": 4473,
	"./logo-extended.webp": 3652,
	"./lp-instructors.png": 4083,
	"./machine-and-deep-learning-in-python.png": 4474,
	"./module-2-programming-for-data-science.png": 4475,
	"./partners/eu.png": 3806,
	"./partners/fund-of-funds.png": 3807,
	"./partners/inovations.png": 3808,
	"./partners/nv3.png": 3805,
	"./partners/vitosha-vp.png": 3804,
	"./platform-snaps-mobile.png": 4084,
	"./platform-snaps.png": 4085,
	"./pluralsight.jpg": 4476,
	"./polygons-2.png": 4477,
	"./pre-footer-icons-1920-dark.webp": 1470,
	"./pre-footer-icons-1920.webp": 1471,
	"./professionals-mobile.png": 4478,
	"./professionals-mobile.webp": 4479,
	"./professionals.png": 4480,
	"./professionals.webp": 4481,
	"./quote.png": 4482,
	"./resource-students.png": 4483,
	"./scholarship-image.png": 4484,
	"./screens-ken.png": 4208,
	"./screens-tina.png": 4209,
	"./second-place.png": 4485,
	"./signup-bg.webp": 4486,
	"./signup-users.png": 3593,
	"./simplilearn.jpg": 4487,
	"./single-polygon-2.png": 4488,
	"./something-better-bg.jpg": 4489,
	"./sprinboard.jpg": 4490,
	"./spring-sale-bg-mobile.jpg": 4491,
	"./spring-sale-bg.jpg": 4492,
	"./start-your-career.webp": 3220,
	"./students-worldwide-mobile.png": 4493,
	"./students-worldwide.png": 4494,
	"./students.png": 3553,
	"./summer-sale-bg-mobile.jpg": 4495,
	"./test-og-background.webp": 4496,
	"./third-place.png": 4497,
	"./treehouse.jpg": 4498,
	"./types-of-learning.png": 4499,
	"./upsell-bg-mobile.jpg": 4210,
	"./upsell-bg.jpg": 4211,
	"./users-group-big.png": 3765,
	"./users-group-bigger.png": 3818,
	"./v2-home-features.webp": 4086,
	"./webinar.jpg": 3882,
	"./winter-campaign-banner.jpg": 4500,
	"./winter-special-bg.jpg": 4501,
	"./winter-special-mobile-bg.jpg": 4502,
	"./you-missed-it-bg.jpg": 4503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3484;